export enum ANNOUNCEMENT_VARIANTS {
  DEFAULT = 'default',
  BOSS_DEFAULT = 'boss-default',
  BOSS_IMPERSONATING = 'boss-impersonating',
  INFO = 'info',
}
